export enum LotClubTypeEnum{
    PARTIAL = 'PARTIAL',
    FULL = 'FULL'
}